import './ViewDetailsDialog.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import useMediaQuery from '../../../../../../hooks/useMediaQuery';
import DialogSpinner from '../../../../../Dialogs/DialogSpinner/DialogSpinner';
import { SingleOrder } from '../../../../Orders/Orders.functions';
import ViewContent from './ViewContent';

type Props = {
  visible: boolean;
  data: SingleOrder | any;
  isLoading: boolean;
  onEdit?: () => void;
  onHide: () => void;
};

function ViewDetailsDialog({ visible, data, isLoading, onHide }: Props) {
  const { t } = useTranslation();

  const dialogFooter = !isLoading && (
    <Button label={t('Close')} onClick={() => onHide()} />
  );

  const isOnMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={
        isLoading
          ? t('Loading...')
          : t('Order {{serialNo}}', { serialNo: data?.seriski_broj ?? '' })
      }
      footer={dialogFooter}
      dismissableMask
      blockScroll
      maximizable
      maximized={isOnMobile}
      className="view-details-dialog"
    >
      {isLoading ? <DialogSpinner /> : <ViewContent data={data} />}
    </Dialog>
  );
}

export default ViewDetailsDialog;
